import React, { useRef } from "react";
import Icon from "../icons/Icon";
import "./FileSelect.css";
import { generateClassName } from "../../../hooks/useAttributes";

interface Props {
  selectedFileName?: string;
  accept?: string;
  onChange: (file: File, content: string) => (void | Promise<void>);
}

export default function FileSelect(props: Props) {

  const [loading, setLoading] = React.useState<boolean>(false);

  const { selectedFileName, onChange, accept } = props;

  const input = useRef<HTMLInputElement | null>(null);

  return (
    <div className="d-flex flex-column gap-2 w-100">
      <label htmlFor="fileInput" className="form-label fw-bold">File</label>
      <div
        className={generateClassName(
          "d-flex file-select w-100 flex-row align-items-center justify-content-center gap-2",
          {
            value: !!selectedFileName,
            onTrue: "file-selected"
          })
        }
        onClick={() => input.current?.click()}
      >
        <div className="d-flex flex-column gap-3">
          <Icon
            loading={loading}
            icon={selectedFileName ? "check" : "file-earmark-plus"}
            size={28}
            color={selectedFileName ? "var(--primaryAccent)" : "var(--gray-400)"}
          />
          <div className="d-flex flex-column">
            <span className="select-file-text">
              {selectedFileName || "No file selected"}
            </span>
            <span className="select-file-accept font-s">
              {selectedFileName ? "Click to replace" : accept}
            </span>
          </div>
        </div>
      </div>
      <input
        ref={input}
        id="fileInput"
        type="file"
        accept={accept}
        className="d-none"
        onChange={(e) => {
          const file = e.target.files?.[0];

          if (!file) {
            return;
          }

          setLoading(true);

          const reader = new FileReader();

          reader.onload = async () => {
            await onChange(file, reader.result as string);

            setLoading(false);
            e.target.value = "";
          };

          reader.readAsDataURL(file);
        }}
      />
    </div>
  )

}